// extracted by mini-css-extract-plugin
module.exports = {"sandboxxPlusBadge":"sandboxx-plus-badge_sandboxxPlusBadge__1itsH","icon":"sandboxx-plus-badge_icon__3xoxh","text":"sandboxx-plus-badge_text__26yya"};